/* Plastics Co product page (pcop-*): dispatch countdown with an estimated delivery window,
   and a sticky add-to-cart bar. The theme re-renders the buy box on every variant change,
   so both re-bind through a MutationObserver and the theme's variant:changed event. */
(function () {
  if (window.PCOP) return;
  window.PCOP = true;

  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  /* UK wall-clock parts, independent of the visitor's own time zone */
  function ukNow() {
    var o = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London', year: 'numeric', month: 'numeric', day: 'numeric',
      hour: '2-digit', minute: '2-digit', hour12: false
    }).formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
    var date = new Date(Date.UTC(+o.year, +o.month - 1, +o.day));
    return { date: date, mins: (parseInt(o.hour, 10) % 24) * 60 + parseInt(o.minute, 10) };
  }
  function isWorkday(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6; }
  function addWorkdays(d, n) {
    var x = new Date(d.getTime());
    while (n > 0) { x.setUTCDate(x.getUTCDate() + 1); if (isWorkday(x)) n--; }
    return x;
  }
  function fmt(d) {
    return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
  }
  /* Only touch the DOM when the text changes, so the MutationObserver below doesn't loop */
  function setHTML(el, html) { if (el && el.innerHTML !== html) el.innerHTML = html; }

  function renderDelivery(card) {
    var cutoff = (parseInt(card.getAttribute('data-cutoff'), 10) || 14) * 60;
    var minD = parseInt(card.getAttribute('data-min-days'), 10) || 1;
    var maxD = parseInt(card.getAttribute('data-max-days'), 10) || 3;
    var dispatchEl = card.querySelector('[data-pcop-dispatch]');
    var etaEl = card.querySelector('[data-pcop-eta]');
    var now;
    try { now = ukNow(); } catch (e) { return; }

    var today = now.date, dispatch, sameDay = isWorkday(today) && now.mins < cutoff;
    if (sameDay) {
      dispatch = today;
      var left = cutoff - now.mins, h = Math.floor(left / 60), m = left % 60;
      setHTML(dispatchEl, 'Order within <strong>' + (h ? h + 'h ' : '') + m + 'm</strong> for <strong>dispatch today</strong>');
    } else {
      dispatch = addWorkdays(today, 1);
      var diff = Math.round((dispatch - today) / 864e5);
      var when = diff === 1 ? 'tomorrow' : 'on ' + DAYS[dispatch.getUTCDay()];
      setHTML(dispatchEl, 'Order now for <strong>dispatch ' + when + '</strong> <small>Orders before 2pm Mon–Fri ship the same day</small>');
    }
    var a = addWorkdays(dispatch, minD), b = addWorkdays(dispatch, maxD);
    setHTML(etaEl, 'Estimated delivery <strong>' + fmt(a) + ' – ' + fmt(b) + '</strong>' +
      '<small>Standard UK mainland delivery, ' + minD + '–' + maxD + ' working days</small>');
  }

  function initDelivery() {
    [].forEach.call(document.querySelectorAll('[data-pcop-deliver]'), function (card) {
      renderDelivery(card);
      if (!card.dataset.timer) {
        card.dataset.timer = '1';
        var t = setInterval(function () {
          if (!card.isConnected) { clearInterval(t); return; }
          renderDelivery(card);
        }, 30000);
      }
    });
  }

  /* Sticky bar: moved to <body> once so re-renders and transformed ancestors can't affect it */
  var bar = null, atc = null, ticking = false;
  function adoptBar() {
    var fresh = document.querySelector('[data-pcop-sticky]:not(#pcop-sticky)');
    if (fresh) {
      if (!bar) { fresh.id = 'pcop-sticky'; document.body.appendChild(fresh); bar = fresh; }
      else { fresh.parentNode.removeChild(fresh); }
    }
    atc = document.querySelector('.product-form__payment-container .product-form__add-button');
  }
  function sizeLabel() {
    var picks = document.querySelectorAll('[data-pcop-pick] .pcop-pick__label strong');
    if (picks.length) return [].map.call(picks, function (s) { return s.textContent.trim(); }).join(' × ');
    var sel = document.querySelectorAll('.product-form__variants .product-form__selected-value');
    return [].map.call(sel, function (s) { return s.textContent.trim(); }).filter(Boolean).join(' · ');
  }
  function syncBar() {
    if (!bar) return;
    var p = document.querySelector('.pco-bb-price__main');
    var priceEl = bar.querySelector('[data-pcop-sticky-price]');
    var sizeEl = bar.querySelector('[data-pcop-sticky-size]');
    if (p && priceEl) priceEl.textContent = p.textContent.replace(/\s+/g, ' ').replace(/^\s*Sale price\s*/i, '').trim();
    if (sizeEl) sizeEl.textContent = sizeLabel();
    var soldOut = atc && atc.disabled;
    bar.querySelector('.pcop-sticky__btn').disabled = !!soldOut;
  }
  function updateBar() {
    ticking = false;
    if (!bar) return;
    if (!atc || !atc.isConnected) adoptBar();
    var show = !!atc && atc.getBoundingClientRect().bottom < 0;
    if (bar.hidden === show) {
      bar.hidden = !show;
      document.documentElement.classList.toggle('pcop-sticky-on', show);
    }
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(updateBar); } }

  /* The sizes table lives in its own section, which the theme doesn't re-render on variant
     change, so move its highlight to the newly selected size here */
  function currentVariantId() {
    var s = document.querySelector('variant-picker script[data-variant]');
    if (s) { try { return String(JSON.parse(s.textContent).id); } catch (e) {} }
    var m = location.search.match(/variant=(\d+)/);
    return m ? m[1] : null;
  }
  function syncTable() {
    var box = document.getElementById('pcop-sizes');
    var id = currentVariantId();
    if (!box || !id) return;
    [].forEach.call(box.querySelectorAll('a[href*="variant="]'), function (a) {
      var on = a.getAttribute('href').split('variant=')[1] === id;
      var cell = a.closest('td') || a;
      if (cell.classList.contains('is-sel') !== on) cell.classList.toggle('is-sel', on);
      if (on) a.setAttribute('aria-current', 'true');
      else if (a.hasAttribute('aria-current')) a.removeAttribute('aria-current');
    });
    [].forEach.call(box.querySelectorAll('tbody tr, .pcop-group'), function (row) {
      var on = !!row.querySelector('.is-sel');
      if (row.classList.contains('is-row') !== on) row.classList.toggle('is-row', on);
    });
  }

  function refresh() { adoptBar(); syncBar(); updateBar(); initDelivery(); syncTable(); }

  function start() {
    refresh();
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('variant:changed', function () { setTimeout(refresh, 80); });
    var root = document.querySelector('[data-section-type="product"]');
    if (root) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        setTimeout(function () { pending = false; refresh(); }, 80);
      }).observe(root, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
